/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { LINKS: de },
  'el-GR': { LINKS: el },
  'en-US': { LINKS: en },
  'es-ES': { LINKS: es },
  'fi-FI': { LINKS: fi },
  'fr-FR': { LINKS: fr },
  'it-IT': { LINKS: it },
  'pl-PL': { LINKS: pl },
  'pt-PT': { LINKS: pt }
};
